<nb-tag-list>
  <nb-tag
    class="tag-restyle"
    style="text-transform: none !important"
    *ngFor="
      let tag of showEllipsedTags ? tagList.slice(0, optionsLimit) : tagList
    "
    [text]="showCombinedText ? tag?.label + ':' + tag?.value : tag.label"
    [removable]="removable"
    (remove)="onRemoveClick($event, tag)"
  ></nb-tag>
  <nb-tag
    *ngIf="
      tagList.length > optionsLimit && optionsLimit > 0 && showEllipsedTags
    "
    style="text-transform: none !important"
    text="+ {{ tagList.length - optionsLimit }} selected"
  >
  </nb-tag>
</nb-tag-list>
